import type { AllergyModel } from '@ctw/shared/api/fhir/models/allergies';
import { sort } from '@ctw/shared/utils/sort';
import { orderBy, uniqBy } from 'lodash-es';

export const applyAllergyFilters = (allergyModel: Array<AllergyModel>, builderId: string) => {
  const sortedByDate = sort(allergyModel, 'recordedDate', 'desc', true);
  // Bump builder owned allergies to the front, so uniqBy favors them!
  const builderOwnedFirst = orderBy(sortedByDate, (a) => a.ownedByBuilder(builderId), 'desc');
  return uniqBy(builderOwnedFirst, 'lowercaseDisplay');
};
